import React, { useState } from "react";

const faqs = [
  {
    question: "Qu'est-ce que 1PARC ?",
    answer: "1PARC est une plateforme digitale qui connecte les propriétaires de voitures, ateliers, fournisseurs de pièces, compagnies d'assurance et assistance routière pour simplifier et digitaliser tout le parcours automobile."
  },
  {
    question: "Comment puis-je m'inscrire sur la plateforme ?",
    answer: "Cliquez sur 'Se connecter' en haut à droite, puis choisissez 'Créer un compte'. Suivez les instructions pour compléter votre inscription."
  },
  {
    question: "Quels sont les avantages pour les ateliers ?",
    answer: "Les ateliers reçoivent des demandes qualifiées, automatisent la gestion des devis/factures et assurent une traçabilité et des paiements plus rapides."
  },
  // Ajoutez d'autres FAQ ici...
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = idx => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <div className="min-h-screen bg-[#23283b] text-white py-20">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-4xl font-bold mb-10 text-center">Foire Aux Questions</h1>
        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <div key={idx} className="border-b border-blue-900 pb-4">
              <button
                className="w-full text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                onClick={() => handleToggle(idx)}
              >
                <span>{faq.question}</span>
                <span>{openIndex === idx ? "−" : "+"}</span>
              </button>
              {openIndex === idx && (
                <div className="mt-2 text-gray-200">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
